import { useParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import SmallAlert from "../../components/ui/alerts/SmallAlert";
import { getAccountByActivationToken } from "../../api/account/activationAPI";
import getAlertTitle from "../../utils/getAlertTitle";
import { statusAlertMap } from "../../lib/Constants";
import { RedirectMessage } from "../../components/ui/RedirectMessage";
import Logo from "../../utils/components/Logo";
import LoadingPlaceholder from "../../components/ui/loading/LoadingPlaceholder";

export default function ActivateAccountPage() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [alertType, setAlertType] = useState(null);

  const fetchActivationAccount = useCallback(async () => {
    const apiUrl = "account/activate-account";
    const data = {
      token: token,
    };

    setLoading(true);
    try {
      const response = await getAccountByActivationToken(apiUrl, data);
      const responseData = await response.json();

      const alertType = statusAlertMap[response.status];
      setAlertType(alertType);
      setLoading(false);
      setMessage(responseData.message);
    } catch (err) {
      setAlertType("error");
      setMessage("Activation failed. Please try again or contact support.");
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchActivationAccount();
  }, [fetchActivationAccount]);

  return (
    <main className="mainOneOne">
      <div className="content" style={{ alignItems: "center" }}>
        <Logo />

        {loading && <LoadingPlaceholder />}

        {!loading && alertType && (
          <>
            <SmallAlert
              alert={true}
              title={getAlertTitle(alertType)}
              type={alertType}
              message={message}
              style={{ marginTop: 16, marginBottom: 16 }}
            />
            {alertType === statusAlertMap[200] && (
              <RedirectMessage
                seconds={15}
                pageName="Sign In"
                redirectPath="/sign-in"
              />
            )}
          </>
        )}

        {!loading && !alertType && token && (
          <p>Please wait while we activate your account...</p>
        )}
      </div>
    </main>
  );
}
